import React from 'react'
import { PuzzleProvider } from './PuzzleContext'
import { PuzzleLine } from './PuzzleLine'
import { PuzzleNode } from './PuzzleNode'
import { PuzzleTopology, PuzzleAnswer } from '@/types/puzzle'

interface PuzzleContainerProps {
  topology: PuzzleTopology
  initialValues?: PuzzleAnswer
  onChange?: (values: PuzzleAnswer) => void
  readOnly?: boolean
}

export const PuzzleContainer: React.FC<PuzzleContainerProps> = ({
  topology,
  initialValues,
  onChange,
  readOnly = false
}) => {
  return (
    <PuzzleProvider 
      topology={topology} 
      initialValues={initialValues}
      onChange={readOnly ? undefined : onChange}
    >
      <div className="relative w-full aspect-square max-w-lg mx-auto select-none">
        {/* Background Image Layer */}
        {topology.background_image && (
          <div 
            className="absolute inset-0 bg-contain bg-center bg-no-repeat opacity-20"
            style={{ backgroundImage: `url(${topology.background_image})` }}
          />
        )}

        {/* SVG Lines Layer */}
        <svg 
          className="absolute inset-0 w-full h-full pointer-events-none z-0"
          viewBox="0 0 100 100"
          preserveAspectRatio="none"
        >
          {topology.lines.map(line => (
            <PuzzleLine key={line.id} lineId={line.id} />
          ))}
        </svg>

        {/* Interactive Nodes Layer */}
        <div className="absolute inset-0 z-10">
          {topology.nodes.map(node => (
            <PuzzleNode key={node.id} nodeId={node.id} />
          ))}
        </div>
      </div>
    </PuzzleProvider>
  )
}
